<div class="route-component">
    <div class="search-component">
        <h4>
            User Roles
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['Role', 'Create']" (click)="upsertUserRole(0)">
                        Add <i class="fas fa-plus"></i>
                    </button>
                    <button *hasPermission="['Role', 'Export']" (click)="downloadUserRoles(paging)">
                        Download <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="refreshGridData()">
                    <button class="search-button" (click)="refreshGridData()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="userRoles"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getUserRoles($event)"
            [showEdit]="showEdit || false"
            (editItem)="upsertUserRole($event)"
            [showDelete]="showDelete || false"
            (deleteItem)="deleteUserRole($event)">
        </pageable-table>
    </div>
</div>